import { useEffect, useState } from 'react';

const breakpoints = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export type Breakpoint = keyof typeof breakpoints;

export function useTailwindBreakpoint() {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function getCurrentBreakpoint(): Breakpoint {
    if (width >= breakpoints['2xl']) return '2xl';
    if (width >= breakpoints.xl) return 'xl';
    if (width >= breakpoints.lg) return 'lg';
    if (width >= breakpoints.md) return 'md';
    if (width >= breakpoints.sm) return 'sm';
    return 'xs';
  }

  const current = getCurrentBreakpoint();

  /** ≥ (min-width) match */
  const gte = (bp: Breakpoint) => width >= breakpoints[bp];

  /** ≤ (max-width) match */
  const lte = (bp: Breakpoint) => width <= breakpoints[bp];

  return {
    breakpoint: current,
    width,

    // Comparison helpers
    gte,
    lte,

    // Optional shortcuts
    isMobile: lte('sm'),
    isTablet: gte('md') && lte('lg'),
    isDesktop: gte('lg'),
  };
}
